import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Modal from "react-bootstrap/Modal";
import React from "react";
import VehicleSynchronizationViewModel from "viewModels/callCenter/search/vehicleRegister/vehicleSynchronization/vehicleSynchronizationViewModel";
import VehicleSynchronizationFistStepView from "./firstStepView";
import VehicleSynchronizationSecondStepView from "./secondStepView";
import { ButtonToolbar, Button } from "react-bootstrap";

export const VehicleSynchronizationView: ViewComponent<VehicleSynchronizationViewModel> = observer(({ vm }) => {
  return (
    <Modal size="lg" show={true} onHide={vm.onClose} dialogClassName="" centered scrollable>
      <Modal.Header className="d-flex justify-content-center">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <Modal.Title>{vm.name}</Modal.Title>
          <span style={{ fontSize: "1.125rem" }}>{vm.licensePlate}</span>
        </div>
        <button
          onClick={vm.onClose}
          type="button"
          className="close"
          style={{ position: "absolute", top: "2.5rem", right: "2.5rem" }}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <VehicleSynchronizationFistStepView vm={vm} />
        {vm.secondStep && <VehicleSynchronizationSecondStepView vm={vm} />}
        <ButtonToolbar className="justify-content-center">
          {!vm.busyWatcher.isBusy && (
            <>
              <Button style={{ minWidth: "11.5rem" }} className="mx-3" type="reset" onClick={vm.onClose} variant="light">
                {!vm.secondStep ? vm.translateGeneral("cancel") : vm.translateGeneral("close")}
              </Button>
              <Button style={{ minWidth: "11.5rem" }} className="mx-3" type="submit" onClick={vm.onContinue}>
                {!vm.secondStep ? vm.translateGeneral("continue") : vm.translate("showVehicleDetail")}
              </Button>
            </>
          )}
        </ButtonToolbar>
      </Modal.Body>
    </Modal>
  );
});

registerView(VehicleSynchronizationView, VehicleSynchronizationViewModel);
